module.exports = __webpack_public_path__ + "static/media/reply.9f766f81.svg";